import Broadcast from './Broadcast';
import {handleToast} from './Toast';
import {numberToBRL} from './formatters/Currency';

function handleCancellationDone(e, vm) {
  const {success, failed} = e;
  const {value} = success || failed;
  if (window.location.pathname.includes('meus-envios')) {
    const releasedOrders = vm.$store.state.meusEnvios.releasedOrders;
    if (success) {
      delete success.value;
      for (let orderId of Object.keys(success)) {
        releasedOrders.some(order => order.id === orderId)
        && vm.$store.dispatch('meusEnvios/deleteOrder', orderId);
      }
    }

    if (failed) {
      delete failed.value;
      for (let [orderId, order] of Object.entries(failed)) {
        const failedOrder = vm.$store.state.meusEnvios.cancellingOrders.find(order => order.id === orderId);
        if (failedOrder) {
          if (order.status === 'posted') {
            vm.$store.dispatch('meusEnvios/editCancellingOrder', {orderId, key: 'status', value: 'posted'});
            continue;
          }
          releasedOrders.push(failedOrder);
          vm.$store.dispatch('meusEnvios/deleteCancellingOrder', orderId);
        }
      }
      releasedOrders.sort((prev, next) => {
        return new Date(next['created_at']) - new Date(prev['created_at']);
      });
      vm.$store.dispatch('meusEnvios/setOrders', releasedOrders);
    }
  }
  const toastData = failed ?
    {
      type: 'warning',
      content: `
      <h3 class="title">Opa! Nem todas as etiquetas foram canceladas</h3>
      <p class="subtitle">Verifique os erros no cancelamento na página <a href="/meus-envios">Meus Envios</a>.</p>
    `,
    }
    :
    {
      type: 'success',
      content: `
      <h3 class="title">Suas etiquetas foram canceladas.</h3>
      <p class="subtitle">
        ${value[0] ? `O valor de R$${numberToBRL(value[0])} foi resgatado para a sua carteira.` : ''}
        ${value[12] ? `O valor de R$${numberToBRL(value[12])} será resgatado em até 4 horas.` : ''}
      </p>
    `,
    };
  handleToast(toastData, vm);
  window['$me_nav']('update-balance');
}

function pusherConnection(vm) {
  const channel = Broadcast.user(MEConfig.get('user.id'));
  channel.listen('.tag.cancel.done', (e) => handleCancellationDone(e, vm));
};

function orderCancellationWatcher(vm) {
  if (!MEConfig.get('user.id')) { // nao esta logado
    return;
  }
  pusherConnection(vm);
};

export {orderCancellationWatcher};
